import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SearchOverlay from './SearchOverlay';

const navItems = [
  { to: '/', label: '首页', end: true },
  { to: '/category/news', label: '娱乐资讯' },
  { to: '/category/video', label: '视频' },
  { to: '/category/topic', label: '互动话题' },
  { to: '/special', label: '专题' },
  { to: '/about', label: '关于' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap cursor-pointer transition-colors ${
      isActive
        ? 'text-primary-600 bg-primary-50'
        : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
    }`;

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-background-200' : 'bg-background-50 border-transparent'
      }`}
    >
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[70px]">
          <div className="flex items-center gap-2 md:gap-6">
            <Link to="/" className="flex items-center gap-2 cursor-pointer shrink-0" aria-label="一起艹 首页">
              <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-xl">
                艹
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl md:text-2xl text-foreground-950">一起艹</span>
                <span className="hidden md:block text-[11px] text-foreground-400 mt-0.5">娱乐·休闲·聚合</span>
              </span>
            </Link>

            <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
              {navItems.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="hidden sm:flex items-center gap-2 pl-3 pr-4 h-10 rounded-full border border-background-200 bg-background-100 text-foreground-400 hover:border-primary-300 cursor-pointer transition-colors"
            >
              <i className="ri-search-line text-base" />
              <span className="text-sm">搜索精彩内容</span>
            </button>
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="sm:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
              aria-label="菜单"
              aria-expanded={menuOpen}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <nav className="lg:hidden pb-4 grid grid-cols-2 gap-2 animate-fade-in" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium text-center cursor-pointer transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        ) : null}
      </div>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>
  );
}